import { render, staticRenderFns } from "./PlayerMoments.vue?vue&type=template&id=871fb02c&scoped=true&"
import script from "./PlayerMoments.vue?vue&type=script&lang=js&"
export * from "./PlayerMoments.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMoments.vue?vue&type=style&index=0&id=871fb02c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871fb02c",
  null
  
)

export default component.exports